import {
  stringifyLoggable,
  debug as commonDebug,
  type Stringifiable,
} from '@imprivata-cloud/common';

export function debug(ctx: string, ...parts: Stringifiable[]) {
  commonDebug(`[IDP-WEB-UI::${ctx}]`, ...parts);
}
export const formatErrorMessage = (
  error: unknown,
  fallback = 'Unknown error',
) => {
  if (error instanceof Error) {
    return error.message;
  }
  if (error && typeof error === 'object') {
    try {
      return stringifyLoggable(error);
    } catch {
      return String(error);
    }
  }
  return error ? String(error) : fallback;
};
